var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0379 3.75C13.5566 3.96875 13.0379 4.1125 12.5004 4.18125C13.0504 3.85 13.4754 3.325 13.6754 2.69375C13.1566 3.00625 12.5816 3.225 11.9754 3.35C11.4816 2.8125 10.7879 2.5 10.0004 2.5C8.53164 2.5 7.33164 3.7 7.33164 5.18125C7.33164 5.39375 7.35664 5.6 7.40039 5.79375C5.17539 5.68125 3.19414 4.6125 1.87539 2.99375C1.64414 3.3875 1.51289 3.85 1.51289 4.3375C1.51289 5.26875 1.98164 6.09375 2.70664 6.5625C2.26289 6.5625 1.85039 6.4375 1.48789 6.25V6.26875C1.48789 7.56875 2.41289 8.65625 3.63789 8.9C3.2446 9.00763 2.8317 9.02261 2.43164 8.94375C2.60139 9.47655 2.93385 9.94275 3.38228 10.2768C3.8307 10.6109 4.37255 10.7961 4.93164 10.8063C3.98391 11.5565 2.80914 11.9621 1.60039 11.9562C1.38789 11.9562 1.17539 11.9437 0.962891 11.9187C2.15039 12.6812 3.56289 13.125 5.07539 13.125C10.0004 13.125 12.7066 9.0375 12.7066 5.49375C12.7066 5.375 12.7066 5.2625 12.7004 5.14375C13.2254 4.76875 13.6754 4.29375 14.0379 3.75Z",
    fill: "#8A7C8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f5e1fde788c5fcd883dc7864a15ecd92.svg";
export { ForwardRef as ReactComponent };